import { UploadFiles } from "@/controllers/upload-files";

export default async function salvarDocumentosOcr(documentos, id_user, tipo) {
    let allSuccessful = true;

    for (const [index, subDocumentos] of documentos.entries()) {
        try {
            for (const [posicao, documento] of subDocumentos.entries()) {
                const formData = new FormData();
                if (documento.file && typeof documento.file === 'string' && documento.file.includes(',')) {
                    const base64Data = documento.file.split(',')[1];
                    let mimetype = documento.mimetype || 'application/octet-stream';

                    mimetype = documento.file.split(',')[0];
                    mimetype = mimetype.split(':')[1];
                    mimetype = mimetype.split(';')[0];

                    const byteCharacters = atob(base64Data);
                    const byteNumbers = new Array(byteCharacters.length);

                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }

                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], { type: mimetype || 'application/octet-stream' });

                    const tp = tipo === 'PJ' ? 31 : 30;

                    formData.append(`file_anexos_${index}_${posicao}`, blob, documento.nm_file || 'sem_nome');
                    formData.append('statusanexo_id', documento.tipo === 'selfie' ? tp : 15);
                    formData.append('cliente_id', id_user);

                    // Faz o upload
                    const response = await UploadFiles(formData);

                    if (response.status === 400) {
                        allSuccessful = false;
                    }
                } else {
                    throw new Error("Documento inválido ou formato incorreto.");
                }
            }

        } catch (e) {
            console.error(`Erro ao processar o documento na posição ${index}:`, e);
            allSuccessful = false;
        }
    }
    return allSuccessful;
}
